module.exports = __webpack_public_path__ + "img/gate.5557e2a9.png";